import request from '@/utils/request'

export function getOrganizationList() {
    return request({
        url: '/gtwg/pc/organizationList',
        method: 'get'
    })
}